module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/license-portal/scal360/view-scal360-renewal-history/view-scal360-renewal-history.component.css
// module id = 998
// module chunks = 1